import { Table, Checkbox } from 'rsuite';
const { HeaderCell, Cell } = Table;

export const CompactCell = (props) => <Cell {...props} style={{ padding: 4 }} />;
export const CompactHeaderCell = (props) => <HeaderCell {...props} style={{ padding: 4 }} />;
export const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
  <Cell {...props} style={{ padding: 0 }}>
    <div style={{ lineHeight: '35px' }}>
      <Checkbox value={rowData[dataKey]} inline onChange={onChange} checked={checkedKeys.some((item) => item === rowData[dataKey])} />
    </div>
  </Cell>
);
